// Mint-Utility: dữ liệu mẫu + logic chia phí / quy đổi tỷ giá (chép từ script board). Chỉ đọc, không gọi mạng.

export type ToolKey = 'merge' | 'ocr' | 'convert' | 'split' | 'fx';
export const TOOLS: [ToolKey, string][] = [['merge', 'Ghép file'], ['ocr', 'OCR & trích chữ'], ['convert', 'Word / Excel → PDF'], ['split', 'Chia phí theo shipper'], ['fx', 'Tỷ giá']];
export const SUB: Record<ToolKey, string> = {
  merge: 'PDF · ảnh · Word · Excel → 1 PDF',
  ocr: 'Ask HANA đọc chữ và bảng trong ảnh / PDF scan · xuất Word, Excel, PDF',
  convert: 'Chuyển Word / Excel sang PDF giữ định dạng',
  split: 'Chia phí lô consol LCL cho từng shipper · xuất Excel / PDF',
  fx: 'Tỷ giá Vietcombank theo ngày · mua chuyển khoản / bán',
};

/** 1.234,5 — dấu chấm hàng nghìn, phẩy thập phân */
export function fmt(n: number, dp = 0): string {
  const v = Number(n) || 0;
  const [i, f] = Math.abs(v).toFixed(dp).split('.');
  return (v < 0 ? '−' : '') + (i ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (f ? ',' + f : '');
}
export function num(v: string): number {
  const s = String(v ?? '').trim();
  if (!s) return 0;
  const n = Number(s.replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

export type FileTy = 'PDF' | 'DOCX' | 'XLSX' | 'XLS' | 'JPG';
export interface MergeFile { name: string; ty: FileTy; pages: number; size: string }
export const MERGE0: MergeFile[] = [
  { name: 'BC_YMLU-SGN-884512.pdf', ty: 'PDF', pages: 2, size: '412 KB' },
  { name: 'SI_SE260639142_rev2.docx', ty: 'DOCX', pages: 3, size: '86 KB' },
  { name: 'PackingList_RUITONGVN-SC.xlsx', ty: 'XLSX', pages: 1, size: '54 KB' },
  { name: 'Anh_niem_chi_YMLU8841203.jpg', ty: 'JPG', pages: 1, size: '1,2 MB' },
];
export const CONVERT0: { name: string; ty: FileTy; meta: string }[] = [
  { name: 'DebitNote_DN26050412.xlsx', ty: 'XLSX', meta: '2 sheet · 48 KB' },
  { name: 'Thu_xac_nhan_LOI_SE260639420.docx', ty: 'DOCX', meta: '1 trang · 31 KB' },
  { name: 'Bang_ke_cont_T10.xls', ty: 'XLS', meta: '1 sheet · 120 KB' },
];
export interface Made { ty: FileTy; name: string; meta: string }
export const MADE0: Made[] = [
  { ty: 'PDF', name: 'Merged_221026081512.pdf', meta: 'Ghép file · 9 trang · 08:15' },
  { ty: 'XLSX', name: 'OCR_PackingList_NAMMY.xlsx', meta: 'OCR · 1 bảng · 08:02' },
  { ty: 'PDF', name: 'ChiaPhi_SE260643210_221026.pdf', meta: 'Chia phí · 3 shipper · hôm qua 16:40' },
];
export const OCR_TEXT = 'PACKING LIST\nShipper: NAMMY CO., LTD · Consignee: Lion Home Pte\nInvoice No.: NM-2610-118 · Date: 20/Oct/2026\n\nNo | Description | Cartons | N.W (kg) | G.W (kg) | CBM\n1 | Rattan chair | 120 | 1.440 | 1.620 | 9,80\n2 | Rattan table | 40 | 880 | 960 | 4,20\n3 | Cushion set | 60 | 300 | 342 | 1,90\nTotal | | 220 | 2.620 | 2.922 | 15,90\n\nMarks: LH/SIN/01-220 · Made in Vietnam';

// ----- Chia phí consol -----
export interface Shipper { name: string; cbm: string; gw: string; job?: string }
export interface Fee { desc: string; amt: string; cur: 'USD' | 'VND'; unit: 'Unit' | 'Shpt' }
export const JOBS: { id: string; kh: string; sub: string; cbm: number; gw: number }[] = [
  { id: 'SE260643210', kh: 'NAMMY', sub: 'LCL · VNSGN → SGSIN · 6,2 CBM', cbm: 6.2, gw: 1840 },
  { id: 'SE260643220', kh: 'SAVITA', sub: 'LCL · VNSGN → SGSIN · 4,8 CBM', cbm: 4.8, gw: 1310 },
  { id: 'SE260643230', kh: 'TAMNGOC', sub: 'LCL · VNSGN → SGSIN · 3,1 CBM', cbm: 3.1, gw: 760 },
  { id: 'SE260643240', kh: 'GREENBUD', sub: 'LCL · VNSGN → SGSIN · 2,4 CBM', cbm: 2.4, gw: 520 },
];
export const SHIPPERS0: Shipper[] = [
  { name: 'NAMMY', cbm: '6,2', gw: '1.840', job: 'SE260643210' },
  { name: 'SAVITA', cbm: '4,8', gw: '1.310', job: 'SE260643220' },
  { name: 'TAMNGOC', cbm: '3,1', gw: '760', job: 'SE260643230' },
];
// Mã phí chỉ dùng mã thật trong sysServiceCode (OCF, THC, BLF, AMS, SLF, TLX)
export const FEES0: Fee[] = [
  { desc: 'OCF', amt: '550', cur: 'USD', unit: 'Unit' }, { desc: 'THC', amt: '170', cur: 'USD', unit: 'Unit' },
  { desc: 'BLF', amt: '45', cur: 'USD', unit: 'Shpt' }, { desc: 'AMS', amt: '35', cur: 'USD', unit: 'Shpt' },
  { desc: 'SLF', amt: '10', cur: 'USD', unit: 'Unit' }, { desc: 'TLX', amt: '30', cur: 'USD', unit: 'Shpt' },
];

export interface SplitResult { pct: number[]; totB: number; vnd: number[]; rows: { fee: Fee; vnd: number; alloc: number[] }[]; colTot: number[]; grand: number }
export function splitCosts(sh: Shipper[], fe: Fee[], basis: 'cbm' | 'gw', rate: number): SplitResult {
  const qty = (s: Shipper) => num(basis === 'gw' ? s.gw : s.cbm);
  const totB = sh.reduce((a, s) => a + qty(s), 0);
  const pct = sh.map((s) => (totB > 0 ? qty(s) / totB : 0));
  const rows = fe.map((fee) => {
    const vnd = fee.cur === 'USD' ? num(fee.amt) * rate : num(fee.amt);
    return { fee, vnd, alloc: sh.map((_, i) => (fee.unit === 'Shpt' ? vnd : vnd * (pct[i] ?? 0))) };
  });
  const colTot = sh.map((_, i) => rows.reduce((a, r) => a + (r.alloc[i] ?? 0), 0));
  return { pct, totB, vnd: rows.map((r) => r.vnd), rows, colTot, grand: colTot.reduce((a, b) => a + b, 0) };
}

// ----- Tỷ giá Vietcombank: [tên, mua tiền mặt, mua chuyển khoản, bán] -----
export const FX: Record<string, [string, number, number, number]> = {
  USD: ['Đô la Mỹ', 26204, 26234, 26454], EUR: ['Euro', 27410, 27687, 28912], JPY: ['Yên Nhật', 168.52, 170.22, 178.3],
  CNY: ['Nhân dân tệ', 3590, 3626, 3742], SGD: ['Đô la Singapore', 19870, 20071, 20716], KRW: ['Won Hàn Quốc', 16.93, 18.81, 20.4],
  GBP: ['Bảng Anh', 33920, 34263, 35364], AUD: ['Đô la Úc', 16830, 17000, 17546], THB: ['Bạt Thái', 704, 782, 812],
};
export function fxUnit(code: string, type: 'transfer' | 'sell'): number | null {
  if (code === 'VND') return 1;
  const r = FX[code];
  if (!r) return null;
  return type === 'sell' ? r[3] || r[2] || r[1] : r[2] || r[3] || r[1];
}
